import { Injectable } from '@angular/core';
import { AlertConfig } from '../interfaces/alert-config';

@Injectable({
    providedIn: 'root',
})
export class AlertsService {

    public get alertList(): AlertConfig[] {
        return this._alertList;
    }

    private _alertList: AlertConfig[] = [];

    open(toast: AlertConfig) {
        this.alertList.push(toast);
        this.manageAutoclose(toast);
    }

    close(toast: AlertConfig) {
        this._alertList = this.alertList.filter(t => t != toast);
    }

    private manageAutoclose(toast: AlertConfig): void {
        if (toast.delay) {
            setTimeout(() => this.close(toast), toast.delay);
        }
    }

}
